<template>
	<vx-card>
		<div ref="customerSearchform">
			<vs-row class="mt-2">
				<vs-col vs-w="4" class="items-center">
					<p class="mb-0 text-subtitle-1 ml-16">ID</p>
				</vs-col>
				<vs-col vs-w="8">
					<vs-input class="w-full" v-model="customerId" placeholder="ID"></vs-input>
				</vs-col>
			</vs-row>
			<vs-row class="mt-2">
				<vs-col vs-w="4" class="items-center">
					<p class="mb-0 text-subtitle-1 ml-16">名前</p>
				</vs-col>
				<vs-col vs-w="8">
					<vs-input class="w-full" v-model="customerName" placeholder="姓名"></vs-input>
				</vs-col>
			</vs-row>
			<vs-row class="mt-2">
				<vs-col vs-w="4">
					<p class="mb-0 text-subtitle-1 ml-16">メールアドレス</p>
				</vs-col>
				<vs-col vs-w="8">
					<vs-input class="w-full" v-model="email" placeholder="メールアドレスを入力"></vs-input>
				</vs-col>
			</vs-row>
			<vs-row class="mt-2">
				<vs-col vs-w="4">
					<p class="mb-0 text-subtitle-1 ml-16">電話番号</p>
				</vs-col>
				<vs-col vs-w="8">
					<vs-input class="w-full" v-model="phoneNumber" placeholder="電話番号を入力"></vs-input>
				</vs-col>
			</vs-row>
			<vs-row class="mt-2">
				<vs-col vs-w="4">
					<p class="mb-0 text-subtitle-1 ml-16">会社名/販売店名</p>
				</vs-col>
				<vs-col vs-w="8">
					<vs-input class="w-full" v-model="companyName" placeholder="株式会社〇〇"></vs-input>
				</vs-col>
			</vs-row>
			<vs-row class="mt-2">
				<vs-col vs-w="4">
					<p class="mb-0 text-subtitle-1 ml-16">住所</p>
				</vs-col>
				<vs-col vs-w="8">
					<vs-input class="w-full" v-model="address" placeholder="例：〇〇市△△区〇〇町0-0"></vs-input>
				</vs-col>
			</vs-row>
			<vs-divider class="mx-4 mt-2"></vs-divider>
			<!-- 検索ボタンと入力クリアボタン -->
			<div class="text-center py-3">
				<vs-button color="primary" class="w-max" @click="searchCustomerList(1)">入力した内容で検索 </vs-button>
			</div>
		</div>
	</vx-card>
</template>
<script>
import { mapActions } from 'vuex'

export default {
	props: {
		pageCustomer: {
			type: Number,
			default: 1
		}
	},
	watch: {
		async pageCustomer(page) {
			await this.searchCustomerList(page)
		}
	},
	data() {
		return {
			isNdDisplayTel: true,
			sortBy: 'id',
			sortDesc: [true],
			pageCount: 0,
			itemsPerPage: 30,
			customerId: '',
			customerName: '',
			email: '',
			companyName: '',
			phoneNumber: '',
			address: '',

			customerSelected: null,
			genderName: ['男', '女', 'その他'],
			attentionFlgName: ['注意', '要注意'],
			customerTypeFlgName: ['個人消費者', '法人消費者', '販売店', '支店', 'その他']
		}
	},
	methods: {
		...mapActions({
			getCustomers: 'customer/getCustomers'
		}),
		async customerSearchReset() {
			await this.$refs.customerSearchform.reset()
			this.isNdDisplayTel = true
		},
		clearData() {
			this.pageCount = 0
			this.customerSelected = null
		},
		// 商品/サービス情報の検索結果取得
		async searchCustomerList(page = 1) {
			if (page == 1) {
				this.$emit('changePage', 1)
			}
			// 検索結果モーダルを開く
			await this.getCustomers({
				id: this.customerId,
				emai: this.email,
				phoneNumber: this.phoneNumber,
				name: this.customerName,
				companyName: this.companyName,
				address: this.address,
				page: page ? page : 1
			})
			this.$emit('afterSearch')
		}
	}
}
</script>
<style scoped>
/* テーブルのヘッダーのフォントサイズ */
.v-data-table ::v-deep th {
	font-size: 18px !important;
	background-color: #bdbdbd;
}

/* 検索結果が「０」の場合に表示するテキストのフォントサイズ */
::v-deep .v-data-table__empty-wrapper > td {
	font-size: 20px !important;
}

/*.centerLoad{*/
/*  position: relative;*/
/*  left: 900%;*/
/*  transform: translateX(-450%);*/
/*}*/
</style>
